module.exports = __webpack_public_path__ + "img/industry.4976c914.png";